import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSubscriptionsUIContext } from "../SubscriptionsUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== "" ? +status : undefined;
 // Filter by all fields
  filter.id = searchText;
  if (searchText) {
    filter.platform = searchText;
    }
  if (searchText) {
    filter.username = searchText;
    }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SubscriptionsFilter({ listLoading }) {
  // Subscriptions UI Context
  const subscriptionsUIContext = useSubscriptionsUIContext();
  const subscriptionsUIProps = useMemo(() => {
    return {
      setQueryParams: subscriptionsUIContext.setQueryParams,
      queryParams: subscriptionsUIContext.queryParams,
    };
  }, [subscriptionsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(subscriptionsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, subscriptionsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      subscriptionsUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "", // values => All=""/Selling=0/Sold=1
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-3">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in all fields
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
